import React, { forwardRef } from 'react'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'

import styles from './ReactTooltip.module.scss'

const tooltipPrimitiveProvider = (props, forwardedRef) => {
  const { className, ...itemProps } = props

  return (
    <TooltipPrimitive.Provider
      {...itemProps}
      ref={forwardedRef}
      className={`${styles.TooltipProvider} ${className || ''}`}
    />
  )
}

const TooltipPrimitiveRoot = (props, forwardedRef) => {
  const { className, ...itemProps } = props

  return (
    <TooltipPrimitive.Root {...itemProps} ref={forwardedRef} className={`${styles.TooltipRoot} ${className || ''}`} />
  )
}

const tooltipPrimitiveTrigger = (props, forwardedRef) => {
  const { className, ...itemProps } = props

  return (
    <TooltipPrimitive.Trigger
      {...itemProps}
      ref={forwardedRef}
      onClick={(event) => event.preventDefault()}
      onMouseDown={(event) => event.preventDefault()}
      onMouseLeave={(event) => event.preventDefault()}
      onBlur={(event) => event.preventDefault()}
      className={`${styles.TooltipTrigger} ${className || ''}`}
    />
  )
}

const tooltipPrimitiveContent = (props, forwardedRef) => {
  const { className, ...itemProps } = props

  return (
    <TooltipPrimitive.Content
      {...itemProps}
      ref={forwardedRef}
      className={`${styles.TooltipContent} ${className || ''}`}
    />
  )
}

const tooltipPrimitiveArrow = (props, forwardedRef) => {
  const { className, ...itemProps } = props

  return (
    <TooltipPrimitive.Arrow {...itemProps} ref={forwardedRef} className={`${styles.TooltipArrow} ${className || ''}`} />
  )
}

export const TooltipProvider = forwardRef(tooltipPrimitiveProvider)
export const TooltipRoot = forwardRef(TooltipPrimitiveRoot)
export const TooltipTrigger = forwardRef(tooltipPrimitiveTrigger)
export const TooltipContent = forwardRef(tooltipPrimitiveContent)
export const TooltipArrow = forwardRef(tooltipPrimitiveArrow)

const ReactToolTip = ({ open, asChild = false, children, content, className, ...rest }) => {
  const { side = 'top', align = 'center' } = rest

  return (
    <TooltipPrimitive.Provider>
      <TooltipPrimitive.Root className={styles.TooltipRoot} delayDuration={100} open={open}>
        <TooltipPrimitive.Trigger className={styles.TooltipTrigger} asChild={asChild}>
          {children}
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Content
          className={`${styles.TooltipContent} ${className}`}
          side={side}
          align={align}
          {...rest}
        >
          {content}
          <TooltipPrimitive.Arrow className={styles.TooltipArrow} width={16} height={11} />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  )
}

export default ReactToolTip
